import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { BfxBlotterAction } from "../../../../../shared/cubiq-services";

export enum BfxContextMenuItemMode {
  OPTIMISTIC,
  PESSIMISTIC,
}

/* export const SALES_APPROVAL_REASONS = [
	CubiqTS.DIReason.ENTRY_CREDIT_FAIL,
	CubiqTS.DIReason.FORCE_TO_DI,
	CubiqTS.DIReason.DAILY_REVAL_CREDIT_FAIL,
	CubiqTS.DIReason.PROXIMITY_REVAL_CREDIT_FAIL,
	CubiqTS.DIReason.FILL_CREDIT_FAIL
];

export const SALES_REJECT_REASONS = [
	CubiqTS.DIReason.ENTRY_CREDIT_FAIL,
	CubiqTS.DIReason.FORCE_TO_DI,
];

export const TRADER_ACCEPT_REJECT_REASONS = [
	CubiqTS.DIReason.SOFT_CUT_OFF,
	CubiqTS.DIReason.CANCEL_DURING_SOFT_CUT_OFF
];


export const CANCEL_REASONS = [
	CubiqTS.DIReason.DAILY_REVAL_CREDIT_FAIL,
	CubiqTS.DIReason.PROXIMITY_REVAL_CREDIT_FAIL
];

export const AMEND_MARKUP_REASONS = [
	CubiqTS.DIReason.FORCE_TO_DI,
	CubiqTS.DIReason.ENTRY_CREDIT_FAIL,
	CubiqTS.DIReason.DAILY_REVAL_CREDIT_FAIL,
]; */

export const CANCEL_ALLOWED_STATES = [CubiqTS.OrderState.ACTIVE];
export const MODIFY_ALLOWED_STATES = [CubiqTS.OrderState.ACTIVE];

export const UNLOCK_ALLOWED_TYPES = [
  CubiqTS.LockType.SI_LOCK,
  CubiqTS.LockType.FILL_LOCK,
  CubiqTS.LockType.FILL_NOW_LOCK,
  CubiqTS.LockType.MODIFY_LOCK,
];

export const UNLOCK_DISALLOWED_STATES = [
  CubiqTS.OrderState.MODIFY_ACCEPTANCE_NEEDED,
  CubiqTS.OrderState.ACCEPTANCE_NEEDED,
  CubiqTS.OrderState.CANCEL_ACCEPTANCE_NEEDED,
];

export const ACCEPT_REJECT_ALLOWED_STATES = [
  CubiqTS.OrderState.MODIFY_ACCEPTANCE_NEEDED,
  CubiqTS.OrderState.ACCEPTANCE_NEEDED,
  CubiqTS.OrderState.CANCEL_ACCEPTANCE_NEEDED,
];

export const SI_UNLOCK_STATES = [CubiqTS.OrderState.DI_NEEDED];

export const CLIENT_ORDERS_AVAILABLE_MODE_MAPPING = new Map<
  BfxBlotterAction | string,
  BfxContextMenuItemMode
>([
  [BfxBlotterAction.ACTION_ORDER_ACCEPT, BfxContextMenuItemMode.PESSIMISTIC],
  [BfxBlotterAction.ACTION_ORDER_REJECT, BfxContextMenuItemMode.PESSIMISTIC],
  [BfxBlotterAction.ACTION_ORDER_MODIFY, BfxContextMenuItemMode.OPTIMISTIC],
  [BfxBlotterAction.ACTION_ORDER_CANCEL, BfxContextMenuItemMode.OPTIMISTIC],
  [BfxBlotterAction.ACTION_ORDER_DUPLICATE, BfxContextMenuItemMode.OPTIMISTIC],
  [BfxBlotterAction.ACTION_ORDER_UNLOCK, BfxContextMenuItemMode.OPTIMISTIC],
  [BfxBlotterAction.ACTION_TRANSFER, BfxContextMenuItemMode.OPTIMISTIC],
  [BfxBlotterAction.ACTION_TAKE, BfxContextMenuItemMode.OPTIMISTIC],
  [BfxBlotterAction.ACTION_VIEW_DETAILS, BfxContextMenuItemMode.OPTIMISTIC],
  [BfxBlotterAction.ACTION_TRADE_VIEW_DETAILS, BfxContextMenuItemMode.OPTIMISTIC],
  [BfxBlotterAction.ACTION_TRADE_EXPORT, BfxContextMenuItemMode.OPTIMISTIC],
]);

export const CLIENT_ORDERS_ENABLED_MODE_MAPPING = new Map<
  BfxBlotterAction | string,
  BfxContextMenuItemMode
>([
  [BfxBlotterAction.ACTION_ORDER_ACCEPT, BfxContextMenuItemMode.PESSIMISTIC],
  [BfxBlotterAction.ACTION_ORDER_REJECT, BfxContextMenuItemMode.PESSIMISTIC],
  [BfxBlotterAction.ACTION_ORDER_MODIFY, BfxContextMenuItemMode.OPTIMISTIC],
  [BfxBlotterAction.ACTION_ORDER_CANCEL, BfxContextMenuItemMode.PESSIMISTIC],
  [BfxBlotterAction.ACTION_ORDER_DUPLICATE, BfxContextMenuItemMode.OPTIMISTIC],
  [BfxBlotterAction.ACTION_ORDER_UNLOCK, BfxContextMenuItemMode.OPTIMISTIC],
  [BfxBlotterAction.ACTION_TRANSFER, BfxContextMenuItemMode.OPTIMISTIC],
  [BfxBlotterAction.ACTION_TAKE, BfxContextMenuItemMode.OPTIMISTIC],
  [BfxBlotterAction.ACTION_VIEW_DETAILS, BfxContextMenuItemMode.OPTIMISTIC],
  [BfxBlotterAction.ACTION_TRADE_VIEW_DETAILS, BfxContextMenuItemMode.OPTIMISTIC],
  [BfxBlotterAction.ACTION_TRADE_EXPORT, BfxContextMenuItemMode.OPTIMISTIC],
]);

/**
 * Some actions can not be OPTIMISTIC no matter how hard you try to cheer them up.
 * Seriously, this is an override on the mappings above, DO NOT MODIFY!
 */
export const CLIENT_ORDERS_ENABLED_MUST_BE_PESSIMISTIC: Array<BfxBlotterAction | string> = [];
